function setSlideExpanded(slide, expanded, returnFocus = false) {
    const toggles = slide.querySelectorAll('.slider-variable-item-toggle');
    const content = slide.querySelector('.slider-variable-item-details');

    if (!content) {
        return;
    }

    slide.classList.toggle('is-expanded', expanded);
    content.setAttribute('aria-hidden', String(!expanded));

    toggles.forEach((toggle) => {
        toggle.setAttribute('aria-expanded', String(expanded));
    });

    if (returnFocus) {
        const trigger = slide.querySelector('.slider-variable-item-stretched-link');

        if (trigger) {
            trigger.focus();
        }
    }
}

function toggleSlide(event) {
    event.stopPropagation();

    const button = event.currentTarget;
    const slide = button.closest('.slider-variable-item');

    if (!slide) {
        return;
    }

    const expanded = button.getAttribute('aria-expanded') === 'true';
    setSlideExpanded(slide, !expanded);
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.slider-variable-item-toggle').forEach((button) => {
        button.addEventListener('click', toggleSlide);
    });

    document.addEventListener('click', (event) => {
        document.querySelectorAll('.slider-variable-item.is-expanded').forEach((slide) => {
            const content = slide.querySelector('.slider-variable-item-details');
            const toggle = event.target.closest('.slider-variable-item-toggle');

            if (content && !content.contains(event.target) && !toggle) {
                setSlideExpanded(slide, false);
            }
        });
    });

    document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') {
            return;
        }

        document.querySelectorAll('.slider-variable-item.is-expanded').forEach((slide) => {
            setSlideExpanded(slide, false, true);
        });
    });
});
